export default __webpack_public_path__ + "static/media/p27.35cf10fd.jpg";